import { render, staticRenderFns } from "./CellRenderCheckbox.vue?vue&type=template&id=20cd4a12&scoped=true"
import script from "./CellRenderCheckbox.vue?vue&type=script&lang=js"
export * from "./CellRenderCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CellRenderCheckbox.vue?vue&type=style&index=0&id=20cd4a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd4a12",
  null
  
)

export default component.exports